const isEmptyVAL = (value) => {
	try {
		if (value === undefined || value === null || (typeof value === "object" && Object.keys(value).length === 0) || (typeof value === "string" && value.trim().length === 0) || (Object.entries(value).length === 0 && value.constructor === Object)) {
			return true;
		}
	} catch (e) {
		console.error("Error in isEmptyVAL:", e);
		return true;
	}
};
export default isEmptyVAL;
